import { gql } from "apollo-boost"

export const getCommentsConsultant = gql`
  query CommentsConsultant(
    $entities: [CommentEntitiesInputType!]!
  ) {
    CommentsConsultant(entities: $entities) {
      id
      fieldName
      userRol
      User
      createdAt
      reviewed
      revision
      comment
      type
      consultant
      parentCommentId
    }
  }
`